import { AlertCircle } from "lucide-react";
import type * as React from "react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { cn } from "@/lib/utils";

function FieldErrorMessage({
  className,
  id,
  message,
  ...props
}: React.ComponentProps<"p"> & {
  message?: string | null;
}) {
  if (!message) {
    return null;
  }

  return (
    <p
      id={id}
      role="alert"
      aria-live="polite"
      className={cn("text-sm text-destructive", className)}
      {...props}
    >
      {message}
    </p>
  );
}

function FormErrorAlert({
  className,
  message,
  title = "Something went wrong",
  ...props
}: Omit<React.ComponentProps<typeof Alert>, "children"> & {
  message?: string | null;
  title?: string;
}) {
  if (!message) {
    return null;
  }

  return (
    <Alert variant="destructive" className={className} {...props}>
      <AlertCircle />
      <AlertTitle>{title}</AlertTitle>
      <AlertDescription>{message}</AlertDescription>
    </Alert>
  );
}

export { FieldErrorMessage, FormErrorAlert };
